<template>
  <v-card
    :flat="!smUp"
    rounded
    :style="smUp ? 'padding: 15px; margin-left: -5%;background: #FFFFFF 0% 0% no-repeat padding-box;box-shadow: 0px 3px 6px #00000029;border-radius: 15px;opacity: 1;':''"
  >
    <v-data-table
      :headers="headers"
      :items="items"
      :single-expand="singleExpand"
      :expanded.sync="expanded"
      item-key="_id"
      @click:row="clicked"
    >
      <template v-slot:item.bSeen="{ item }">
        <v-btn rounded color="#EAEAEA" v-if="!item.bSeen" @click="read(item._id)">No leído</v-btn>
        <v-btn rounded color="#78E6AF" v-else @click="read(item._id)">Leido</v-btn>
      </template>

      <template v-slot:expanded-item="{ headers, item }">
        <td :colspan="headers.length">{{ item.message }}</td>
      </template>
    </v-data-table>
  </v-card>
</template>
<script>
export default {
  data: () => ({
    statusOptions: [
      { name: "No leído", id: 0 },
      { name: "Leído", id: 1 },
    ],
    expand: false,

    expanded: [],
    singleExpand: true,
    client_to_edit: {},
    client_to_delete: null,
    b_edit_client: false,
    b_delete_client: false,
    delete_icon: "mdi-delete",
    edit_icon: "mdi-pencil",
    headers: [
      { text: "Nombre", value: "name", align: "left" },
      { text: "Correo electrónico", value: "email", align: "left" },
      { text: "Teléfono", value: "phone", align: "center" },
      { text: "Motivo del contacto", value: "motive", align: "center" },
      { text: "Estatus", value: "bSeen", width: "250px" },
    ],
  }),
  filters: {
    toCurrency(value) {
      value = Number(value);
      var formatter = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
        minimumFractionDigits: 0,
      });
      return formatter.format(value);
    },
    formatDate(date) {
      /*var d = date.split(/\D+/g).map(function(v) {
        return parseInt(v, 10);
      });
      let newDate =  new Date(d[0], d[1] - 1, d[2], d[3], d[4], d[5]);*/
      date = new Date(date);
      date.setHours(24);
      let monthArray = [
        "Ene",
        "Feb",
        "Mar",
        "Abr",
        "May",
        "Jun",
        "Jul",
        "Ago",
        "Sept",
        "Oct",
        "Nov",
        "Dic",
      ];
      let day = date.getDate();
      if (day < 10) day = "0" + day;
      let month = date.getMonth();
      let year = date.getFullYear();
      return `${day}/${monthArray[month]}/${year}`;
    },
  },
  methods: {
    update() {
      this.$emit("update");
    },
    clicked(value) {
      if (this.expanded.length == 0) {
        this.expanded.push(value);
        console.log(value)
        if(!value.bSeen){
        this.read(value._id);
        }
      } else {
        if (this.expanded[0]._id == value._id) {
          this.expanded.pop();
        } else {
          this.expanded.pop();
          this.expanded.push(value);
        }
      }
    },
    edit_client(client) {
      this.client_to_edit = client;
      this.b_edit_client = true;
    },
    delete_client(client) {
      this.client_to_delete = client._id;
      this.b_delete_client = true;
    },
    read(client) {
      let that = this;

      var config = {
        method: "patch",
        url: "https://api.genvamex.com/api/contacts/" + client,
        headers: {
          Authorization:
            this.usr_token,
        },
      };

      db(config)
        .then(function (response) {
          
          const alert = {
            color: "success",
            text: response.data.message,
          };
          that.$store.commit("toggle_alert", alert);

          that.update();
        })
        .catch(function (error) {
          console.log(error)
        });
    },
  },
  components: {
    ClientEdit: () => import("@/components/sections/Admin/Clients/ClientEdit"),
    ClientDelete: () =>
      import("@/components/sections/Admin/Clients/ClientDelete"),
  },
  props: {
    items: Array,
  },
  computed: {
    smUp() {
      return this.$vuetify.breakpoint.smAndUp;
    },
        usr_token() {
      return "Bearer " + this.$store.state.token;
    },
  },
};
</script>
<style scoped>
.attribute_flex {
  margin-top: 18px;
}
hr {
  height: 0.5px;
  color: rgba(140, 140, 140, 0.112);
  background-color: rgba(114, 114, 114, 0.112);
  border-color: transparent;
}
.attribute_name {
  font-weight: bold;
  color: #000000;
  font-size: 12px;
  font-family: "Open sans", sans-serif;
}
.attribute_value {
  color: #000000;
  font-size: 12px;
  font-family: "Open sans", sans-serif;
}
.application_table_row {
  cursor: pointer;
}


.text_content {
  margin-top: 15px;
  color: #000000;
  font-size: 12px;
  font-family: "Open sans", sans-serif;
}

.v-select__selection {
  width: 100%;
  justify-content: center;
}
</style>
<style>
.zero-class .v-icon,
.one-class .v-icon,
.two-class .v-icon,
.three-class .v-icon {
  color: white;
}

.v-select__selection {
  width: 100%;
  justify-content: center;
}
</style>